import { meCached } from '@/services/auth';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export default function useMe(options = {}) {
    const { enabled = true } = options;
    const queryClient = useQueryClient();

    const {
        data: userData,
        isLoading: isLoadingMe,
        isError: isErrorMe,
        error: errorMe,
        refetch: refetchMe,
    } = useQuery({
        queryKey: ['me'],
        queryFn: async () => {
            try {
                return await meCached();
            } catch (error) {
                return null;
            }
        },
        enabled,
        staleTime: 120000,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });

    const forceRefetchMe = useCallback(async () => {
        const user = await meCached({ forceUpdate: true });
        queryClient.setQueryData(['me'], user);
        return { data: user };
    }, [queryClient]);

    const HAS_EXPERIMENTAL_FEATURES_ADD_FEES = userData?.experimental_features?.includes('additional_installments_interest')

    return {
        userData,
        isLoadingMe,
        isErrorMe,
        errorMe,
        refetchMe,
        forceRefetchMe,
        hasExperimentalFeaturesAddFees: HAS_EXPERIMENTAL_FEATURES_ADD_FEES
    };
}
